module.exports = __webpack_public_path__ + "img/department-line.1b423c53.svg";